import React from 'react';

const SealBadge = ({ type }) => {
  const isVerified = type === 'verified';
  
  if (isVerified) {
    return (
      <div className="relative group flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 transition-transform hover:scale-110" title="Verified Product">
        <img 
          src="/images/verified_badge.png" 
          alt="Verified" 
          className="w-full h-full object-contain drop-shadow-sm mix-blend-multiply" 
        />
      </div>
    );
  }

  // Trusted Badge
  return (
    <div className="relative group flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 transition-transform hover:scale-110" title="Trusted Product">
      <img 
        src="/images/trusted_badge.png" 
        alt="Trusted" 
        className="w-full h-full object-contain drop-shadow-sm mix-blend-multiply" 
      />
    </div>
  );
};

export default SealBadge;
